<ng-container *ngIf="isLoadingPermissions; else loadedPermissions">
    <ngx-skeleton-loader
        count="5"
        [theme]="{ 
            'height.px': 50
        }"
    ></ngx-skeleton-loader>
</ng-container>
<ng-template #loadedPermissions>
    <app-data-grid-comp
        [columns]="columns"
        [bindingType]="bindingType"
        [view]="view"
        [gridData]="gridData"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        category="tbl_Projects"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectableMode: 'multiple',
            selectRowBy: 'id'
        }"
        clickableRows="true"
        [isLoading]="isLoading"
        [clearSelectedItems]="clearSelectedItems"
        [tableId]="db_tables.Projects"
        [accessAndHistoryURL]="accessAndHistoryURL"
        [parentModelId]="employeeID"
        [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
        (emitPageChangeEvent)="pageChange($event)"
        (emitOpenDialogEvent)="getProject($event)"
        (emitDeleteEvent)="deleteProjects($event)"
    ></app-data-grid-comp>
</ng-template>